import React, { useState, useEffect } from "react";
import {Col, Container, Modal, Row, Form }from 'react-bootstrap';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import { useSelector } from "react-redux";
import Button from "../Controls/Button";
import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from "../../utils/helpers/APICom";

const TreatedTripDialogue = (props) => {
    
    const { DispatchVehicleData, DispatchDriverData }= useSelector((store) => store.combinedata);
    const [vehicleFilterMultiSelect, setVehicleFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Select Vehicle",displayValue:"name",emptyRecordMsg:"N/A",id:"ddlDAVehicle",className:"ddlDAVehicle",SelectAllPlaceHolder:"All Vehicles", AllItemsSelectedPlaceHolder:"All Vehicles",styles:{width:"160px", marginLeft:"10px"}});
    const [TreatedReasonsSingleSelect, SetTreatedReasonsMultiSelect] = useState({options: [{"name":"", "id":""}, {"name":"Treated Too Late", "id":"16"}, {"name":"Treated Dropped", "id":"4"}, {"name":"Driver Got Lost", "id":"13"}, {"name":"Vehicle Breakdown", "id":"12"}, {"name":"Accident", "id":"11"}],selectedValues:[],placeholder:"Treated Reasons Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"TreatedReasonsSelect",className:"TreatedReasonsSelect",singleSelect:true, showCheckbox:false, TriggerSelectEventOnDataPopulate: false,styles:{width:"150px", marginLeft:"10px"}});
    const [SelectedReason, SetSelectedReason] = useState([]);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Dispatch Action', body:'', btnCanceText: 'Ok', btnOkText: 'Cancel', 'ConfirmationSuccessFunctionName': ''});

    useEffect(()=> {
        if(props.GridRowData !== undefined){
        }
    }, [props.GridRowData]);
    
    const VehicleSelectCallback = () => {

    }
   

    const handleCloseDialog = () => {
        UnMountComponent();
    }

    const UnMountComponent = () => {
        if(props.showDialog)
        {
            props.setActionsDialog(false);
        }
    }
    const BtnTreatedClick = (e) => {
        //alert("Treated Click" + props.GridRowData["TripRequestStatus"] + props.GridRowData["ServiceStatus"] + props.GridRowData["TableSource"] + props.GridRowData["CreatedBy"] + props.GridRowData["iSRATSPID"] + props.GridRowData["TripRequestStatus"]);
        try{
            var Queue = "";
            var serviceStatus = props.GridRowData[0]["ServiceStatus"];
            var triprequestStatus = props.GridRowData[0]["TripRequestStatus"];
            var tableSource = props.GridRowData[0]["TableSource"];
            if (triprequestStatus.toLowerCase().includes("cancel")) {
                Queue = "Cancelled";
            }
            else if (triprequestStatus.toLowerCase() == "noshow") {
                Queue = "Cancelled";
            }
            else if (serviceStatus.toLowerCase() == "dispatched") {
                Queue = "InProgress";
            }
            else {
                if (tableSource == "FromOnDemandTable")
                    Queue = "OnDemand";
                else
                    Queue = "Scheduled";
            }
            var CreatedBy = props.GridRowData[0]["CreatedBy"];
            var iATSPID = props.GridRowData[0]["iSRATSPID"];
            var HasAffiliateInThirdParty = false;
            //HasAffiliateInThirdParty = CheckIfTripIsBrokerTrip(iATSPID);
            var HasAffiliateInThirdParty = false

            var CreatedBy = props.GridRowData[0]["CreatedBy"];
            if (CreatedBy == "(ExternalDispatch)" && Queue == "Cancelled") {
                alert("This is a broker trip, Treated is not allowed!");
                return false;
            }

            if (CreatedBy != "(ExternalDispatch)" && HasAffiliateInThirdParty == true) {
                alert("Treated is not allowed for External Trip!");
                return false;
            }
            setConfirmationModalObj({show: true, title:'Confirm Treated', body:"Are You Sure To Update This Request As Treated?", btnCanceText: 'No', btnOkText: 'Yes', ConfirmationSuccessFunctionName: 'UpdateAsTreated'});
        }
        catch(e){
        }
    }
    function TreatedReasonsSelectCallback(selectedReasons) {
        SetSelectedReason(selectedReasons);
      }
    const dropdownpadding = {
        paddingLeft: '5px'
      };


    const UpdateAsTreated = async () => {
        let treatedreason = "";
        TreatedReasonsSingleSelect.options .forEach(function (element) {
            if(element.id == SelectedReason){
                treatedreason = element.name
            }
          });


        let serviceid = props.GridRowData[0]["ServiceID"];
        let requestObj = {
            "ServiceID":serviceid,
            "iModifiedByUID":0,
            "tReason":treatedreason,
            "tReasonID":parseInt(SelectedReason[0])
        }
        let response = await APICom.fetchData("", "TripActions/UpdateAsTreated", "post", { "Content-Type": "application/json" }, requestObj, null);
        if(response.error!="") {
            alert(response.error);
        }
        else{
            let data = response.data;
            if (data[0].Action == "True") {
                UnMountComponent();
            }
            else {
                alert( "Trip could not be marked treated. Please contact system administrator!");
                return false;
            }
        }
    }
    const handleConfirmationModalOkFunction = () => {
        switch(confirmationModalObj.ConfirmationSuccessFunctionName) {
            case "UpdateAsTreated":
                UpdateAsTreated();
                break;
            default:
                alert("No function assigned to confirmation dialog for ok/yes");
                break;
        }
    }
    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        handleConfirmationModalOkFunction();
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnMountComponent();
    }
    return(
        <>
        {props.showDialog &&
            <Modal show={props.showDialog} size="lg" 
            aria-labelledby="contained-modal-title-vcenter" animation={false}>
                <Modal.Header closeButton onClick={handleCloseDialog}>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Confirm Treated Trip
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body className="grid-example" style={{height:"400px"}}>
                        <Container>
                            <Row>
                            <Col xs={6} md={6}>Please select treated reason:</Col> 
                            </Row>
                        <Row>
                        <Col xs={6} md={6}><MultiSelectDropdown options={TreatedReasonsSingleSelect} singleselect="true" style={dropdownpadding} SelectionChangeCallback={TreatedReasonsSelectCallback} />  </Col>
                        </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDialog} value="Cancel">Cancel</Button>
                    <Button className="activate_btn_ok" onClick={BtnTreatedClick} value="Ok" style={{width:"100px"}}>Yes</Button>
                </Modal.Footer>
            </Modal>}
                <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
            btnOkText={confirmationModalObj.btnOkText}  ShowCancelButton="true" />
        </>
        
    );
}

export default TreatedTripDialogue;